// Globals
import { useTranslation } from 'react-i18next';

// Components
import { OrderActionState } from '../OrderActionState/OrderActionState';
import { PropertyActionState } from '../PropertyActionState/PropertyActionState';
import { StyledBlock, StyledCard, StyledLabel, StyledText } from './LogCardStyles';

// Helpers
import { DateFormats } from '@/constants/dates';
import { formatDate } from '@/utils';

// Models
import { EntityType, IBaseActionLog } from '@/models/logs.model';

// Modules
type TLogCardProps = {
  log: IBaseActionLog;
  entityType: EntityType;
};

const LogCard = ({ log, entityType }: TLogCardProps) => {
  const { t } = useTranslation(['common', 'order']);

  return (
    <StyledCard>
      <StyledBlock>
        <StyledLabel>{t('label_date_and_time')}</StyledLabel>
        <StyledText>{formatDate(log.created, DateFormats.FULL_DATE_WITH_TIME)}</StyledText>
      </StyledBlock>
      <StyledBlock>
        <StyledLabel>{t('label_action')}</StyledLabel>
        {entityType === EntityType.ORDER ? <OrderActionState log={log} /> : <PropertyActionState log={log} />}
      </StyledBlock>
    </StyledCard>
  );
};

export default LogCard;
